/**
 * Helper functions
 *
 * @return void
 */

/**
 * Globally used variables
 */
export const body = document.querySelector('body');
export const header = document.querySelector('.c-header');
export const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
export const isUserLoggedIn = body.classList.contains('logged-in');
export const wpAdminBarSpace = isUserLoggedIn ? (isMobile ? 46 : 32) : 0;
export const activeClass = 'is-active';
export const hiddenClass = 'is-hidden';
export const mobileMenuOpenClass = 'is-mobile-menu-open';
export const modalOpenClass = 'is-modal-open';
export const searchOpenClass = 'is-search-open';
export const stickyHeaderClass = 'is-header-sticky';
export const bannerActiveClass = 'is-banner-active';

/**
 * Helper Function that checks if an element exists in page
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const isElementInPage = (node) => {
	return (node === document.body) ? false : document.body.contains(node);
};

/**
 * Helper Function that gets the element's computed width
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const getElementComputedWidth = (el) => {
	const style = el.currentStyle || window.getComputedStyle(el),
		width = el.offsetWidth, // or use style.width
		margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
		padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
		border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

	return width + margin - padding + border;

};

/**
 * Helper Function that gets the element's computed width
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const getElementComputedStyle = (el) => {
	return el.currentStyle || window.getComputedStyle(el);
};

/**
 * Helper Function to toggle between two classes using Vanilla JS
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const toggleCSSClasses = (el, ...cls) => cls.map(cl => el.classList.toggle(cl));

/**
 * Helper Function that finds the ancestor of a specific element
 *
 * @param el  - The element that is used as the point from where we start
 * @param sel - The element that we would like to target
 * @return void
 * @since  1.0.0
 * @access public
 */
export const findAncestor = (el, sel) => {
	while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, sel))) {
		;
	}
	return el;
};

/**
 * Helper Function that provides the closest selector
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const getClosest = function (elem, selector) {

	// Element.matches() polyfill
	if(!Element.prototype.matches) {
		Element.prototype.matches =
			Element.prototype.matchesSelector ||
			Element.prototype.mozMatchesSelector ||
			Element.prototype.msMatchesSelector ||
			Element.prototype.oMatchesSelector ||
			Element.prototype.webkitMatchesSelector ||
			function (s) {
				var matches = (this.document || this.ownerDocument).querySelectorAll(s),
					i = matches.length;
				while (0 <= --i && matches.item(i) !== this) {
				}
				return -1 < i;
			};
	}

	// Get the closest matching element
	for (; elem && elem !== document; elem = elem.parentNode) {
		if(elem.matches(selector)) {
			return elem;
		}
	}
	return null;
};

/**
 * Helper Function that checks if an element has a specific class
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const hasClass = function (el, cls) {
	return el.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
};

/**
 * Helper Function that adds an event listener only if El exists
 *
 * @return void
 * @since  1.0.0
 *
 * @access public
 */
export const addEventListenerIfElExists = function (element, event = 'click', targetFunction) {
	if('undefined' != typeof (element) && null != element) {
		element.addEventListener(event, targetFunction);
	}
};

/**
 * Helper Function that adds an event listener only if El exists
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const addEventListenersIfElExists = function (element, event = 'click', targetFunction) {

	if('undefined' != typeof (element) && null != element) {
		element.forEach((el) => {
			el.addEventListener(event, targetFunction);
		});
	}
};

/**
 * Set Animation Fade
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const setAnimationFade = function (selectedElement, currentCount, interval, animationName, activeClass = 'animated') {

	document.querySelector(`${selectedElement}[data-count="${currentCount}"]`).classList.add(activeClass);
	document.querySelector(`${selectedElement}[data-count="${currentCount}"]`).classList.add(animationName);

	setTimeout(() => {
		document.querySelector(`${selectedElement}[data-count="${currentCount}"]`).classList.remove(activeClass);
		document.querySelector(`${selectedElement}[data-count="${currentCount}"]`).classList.remove(animationName);
	}, interval);
};


/**
 * Match Height
 *
 * Get the selected elements height, find the one with the maximum height and apply to all
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const matchHeight = function (selectedElement) {

	// Grab divs with the class name 'match-height'
	const selectedElements = document.querySelectorAll(selectedElement);

	// Find out how my divs there are with the class 'match-height'
	const arrayLength = selectedElements.length;
	let heights = [];

	// Create a loop that iterates through the selectedElements variable and pushes the heights of the divs into an empty array
	for (let i = 0; i < arrayLength; i++) {
		heights.push(selectedElements[i].offsetHeight);
	}

	// Find the largest of the divs
	function getHighest() {
		return Math.max(...heights);
	}

	// Set a variable equal to the tallest div
	const tallest = getHighest();

	// Iterate through selectedElements and set all their height style equal to the tallest variable
	for (let i = 0; i < selectedElements.length; i++) {
		selectedElements[i].style.height = tallest + 'px';
	}
};

/**
 * Show an element
 *
 * @param elem
 */
export const show = function (elem) {
	elem.style.display = 'block';
};

/**
 * Hide an element
 *
 * @param elem
 */
export const hide = function (elem) {
	elem.style.display = 'none';
};

/**
 * Visually show an element
 *
 * @param elem
 */
export const visible = function (elem) {
	elem.style.opacity = 1;
	elem.style.visibility = 'visible';
	elem.style.pointerEvents = 'all';
};

/**
 * Visually hide an element
 *
 * @param elem
 */
export const invisible = function (elem) {
	elem.style.opacity = 0;
	elem.style.visibility = 'hidden';
	elem.style.pointerEvents = 'none';
};


/**
 * Toggle element visibility
 *
 * @param elem
 */
export const toggle = function (elem) {

	// If the element is visible, hide it
	if('block' === window.getComputedStyle(elem).display) {
		hide(elem);
		return;
	}

	// Otherwise, show it
	show(elem);

};

/**
 * Debounce
 *
 * Limits the rate at which a function can fire.
 * https://davidwalsh.name/javascript-debounce-function
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const debounce = function (func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		var later = function () {
			timeout = null;
			if(!immediate) {
				func.apply(context, args);
			}
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if(callNow) {
			func.apply(context, args);
		}
	};
};

/**
 * onOrAfterLoad
 *
 * Calls a function on page load, or immediately if page has already loaded.
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const onOrAfterLoad = function (fn) {
	if('complete' === document.readyState) {
		fn();
	} else {
		window.addEventListener('load', () => {
			fn();
		});
	}
};

/**
 * Helper Function that creates a cookie
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const createCookie = function (name, value) {
	let date = new Date();
	date.setTime(date.getTime() + (60 * 60 * 1000 * 24 * 30));
	const expires = '; expires=' + date.toGMTString();

	document.cookie = name + '=' + value + expires + '; path=/';
};


/**
 * Helper Function that deletes a cookie
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const deleteCookie = function (name, value) {
	let date = new Date();
	date.setTime(date.getTime() + (30 * 1000));
	const expires = '; expires=Thu, 01 Jan 1970 00:00:00 ';

	document.cookie = name + '=' + value + expires + '; path=/';
};


/**
 * Helper Function that gets a cookie
 *
 * @return void
 * @since  1.0.0
 * @access public
 */
export const getCookie = function (name) {
	const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
	return v ? v[2] : null;
};


/**
 * Is Mobile Device
 *
 * @return {boolean}
 */
export function isMobileDevice() {
	var check = false;
	(function (a) {
		if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
			check = true;
		}
	})(navigator.userAgent || navigator.vendor || window.opera);
	return check;
}


/**
 * Get Progress
 *
 * @param {int} progress is the progress value
 * @param {int} number is the number of numbers after comma
 * @returns
 */
export function getProgress(progress, number = 3) {
	return progress.toFixed(number) * 100;
}
